import { ArrowDown, ArrowUp } from 'lucide-react';
import { tr } from '@/lib/i18n-core';
import { cn } from '@/lib/utils';
import type { VitalReading } from './vitals';

export function VitalTile({ reading, size = 'md' }: { reading: VitalReading; size?: 'sm' | 'md' }) {
  const Icon = reading.icon;
  const flagged = reading.flag !== null;
  const FlagIcon = reading.flag === 'low' ? ArrowDown : ArrowUp;
  return (
    <div
      className={cn(
        'flex min-w-0 items-center gap-2.5 rounded-xl border bg-card transition-colors',
        size === 'sm' ? 'px-2.5 py-1.5' : 'px-3 py-2.5',
        flagged && 'border-destructive/40 bg-destructive/5',
      )}
      title={flagged ? tr('opd', reading.flag === 'low' ? 'vital_below_range' : 'vital_above_range') : undefined}
    >
      <span
        className={cn(
          'grid shrink-0 place-items-center rounded-lg',
          size === 'sm' ? 'h-7 w-7' : 'h-9 w-9',
          flagged ? 'bg-destructive/15 text-destructive' : reading.tone,
        )}
        aria-hidden
      >
        <Icon className={size === 'sm' ? 'h-3.5 w-3.5' : 'h-4 w-4'} />
      </span>
      <span className="min-w-0 leading-tight">
        <span className="block truncate text-[11px] font-medium text-muted-foreground">{reading.label}</span>
        <span className="flex items-baseline gap-1">
          <span className={cn('tabular font-semibold', size === 'sm' ? 'text-sm' : 'text-base', flagged && 'text-destructive', !reading.value && 'text-muted-foreground/60')}>
            {reading.value ?? '—'}
          </span>
          {reading.value && reading.unit && <span className="text-[11px] text-muted-foreground">{reading.unit}</span>}
          {flagged && <FlagIcon className="h-3 w-3 self-center text-destructive" aria-hidden />}
        </span>
      </span>
    </div>
  );
}
